var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMerge = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.2643106 18.034641c-4.4682343 5.338533 1.4788179 7.30554 4.8613594 10.385631",
    fill: "none",
    stroke: "#383838"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.0273438 9.5019532c-2.8183472.0466368-5.2870436 1.2538898-6.2832033 4.1933598-.98846778 2.91677 1.170551 8.183301 5.9316407 5.841796 1.0301673-.506636 1.9215798-.859622 2.7050778-1.099609l1.007813-8.4746093c-1.127842-.3031508-2.2675136-.479038-3.3613282-.4609375z",
    fill: "#8cbe8c",
    fillRule: "evenodd",
    stroke: "#555753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.851562 10.798828.53125 7.535156c1.582361.661554 2.072438 2.166016 3.173829 2.166016 2.438571 0 4.941406-1.699014 4.941406-3.873047 0-1.944514.0964-3.806221-.992188-4.876953-1.894133-1.8630709-2.899234.736606-7.654297-.951172z",
    fill: "#8cbe8c",
    fillRule: "evenodd",
    stroke: "#555753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.4867307 12.874675c2.1566303-1.439655 3.9242913-1.038192 5.6455263-.416974",
    fill: "none",
    stroke: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.2588278 15.1439c2.0828752-1.042625 4.1458402-.996671 6.1991992-.425475",
    fill: "none",
    stroke: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.1710899 17.517655c2.2447951-1.079532 4.4669191-.957514 6.6824631-.48673",
    fill: "none",
    stroke: "#383838"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMerge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/merge.35139ea9.svg";
export { ForwardRef as ReactComponent };